import { render, staticRenderFns } from "./SetupWizard.vue?vue&type=template&id=2742770e&scoped=true&"
import script from "./SetupWizard.vue?vue&type=script&lang=js&"
export * from "./SetupWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2742770e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VFadeTransition,VOverlay})
